import { ITagResult } from '~src/httpClient/serverApi/types/IResponse';
import { TagRequest } from '~src/httpClient/TAG/TagRequest';

import { DeleteCustomDomainSettingRequest } from '../types/CustomDomainTypes';


export class DeleteCustomDomainTagRequest extends TagRequest<DeleteCustomDomainSettingRequest, IDeleteCustomDomainSettingResult> {
    constructor(request: DeleteCustomDomainSettingRequest) {
      super('custom_domains_service', 'deleteSiteCustomDomainSettings', request);
    }
}

export type IDeleteCustomDomainSettingResult = ITagResult;